import { AccentColor } from "@/lib/colors";

const variantClasses: Record<AccentColor, string> = {
  [AccentColor.Bubblegum]: "text-bubblegum-text bg-bubblegum/15",
  [AccentColor.Lavender]: "text-lavender-text bg-lavender/15",
  [AccentColor.Aegean]: "text-aegean-text bg-aegean/15",
  [AccentColor.Success]: "text-success-text bg-success/15",
  [AccentColor.Warning]: "text-warning-text bg-warning/15",
  [AccentColor.Error]: "text-error-text bg-error/15"
};

interface PillBadgeProps {
  label: string;
  variant: AccentColor;
}

export function PillBadge({ label, variant }: PillBadgeProps) {
  return (
    <span
      className={`rounded-xl px-3 py-1 text-xs font-body font-bold tracking-widest uppercase self-start ${variantClasses[variant]}`}
    >
      {label}
    </span>
  );
}
